import { render, staticRenderFns } from "./ClassesDetailItem.vue?vue&type=template&id=43b6cee1&scoped=true&"
import script from "./ClassesDetailItem.vue?vue&type=script&lang=js&"
export * from "./ClassesDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./ClassesDetailItem.vue?vue&type=style&index=0&id=43b6cee1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b6cee1",
  null
  
)

export default component.exports